<template>
  <b-modal
    id="modal-update-moneylender-license-expiry"
    centered
    title="修改放債人牌照到期日及號碼"
    size="lg"
    @ok="handleUpdate"
    ok-title="更新"
    cancel-title="取消"
    :ok-disabled="loading"
    no-close-on-backdrop
    no-close-on-esc
  >
    <div>
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <b-form class="pt-1" @submit.prevent="handleSubmit(onSubmit)">
            <b-row>
              <b-col cols="12">
                <b-form-group label="財務公司名稱：" label-for="company_name">
                  <b-form-input
                    id="company_name"
                    :value="supplier.company_name_cn || supplier.company_name_en"
                    disabled
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="放債人號碼"
                  rules=""
                >
                  <b-form-group
                    label="放債人號碼："
                    label-for="moneylender_number"
                    label-cols-md="4"
                  >
                    <b-form-input
                      id="moneylender_number"
                      v-model="moneylenderNumber"
                      placeholder="請輸入放債人號碼"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12">
                <b-form-group label="當前放債人牌照到期日：" label-for="current_expiry_date">
                  <b-form-input
                    id="current_expiry_date"
                    :value="supplier.moneylender_license_expiry_date || '未設定'"
                    disabled
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="新的放債人牌照到期日"
                  rules="required"
                >
                  <b-form-group
                    label="新的放債人牌照到期日："
                    label-for="new_expiry_date"
                    label-cols-md="4"
                    class="required"
                  >
                    <el-date-picker
                      id="new_expiry_date"
                      v-model="newExpiryDate"
                      type="date"
                      placeholder="選擇新的放債人牌照到期日"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      style="width: 100%"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </b-form>
        </b-overlay>
      </validation-observer>
    </div>
  </b-modal>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BForm,
  BFormGroup,
  BFormInvalidFeedback,
  BOverlay,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import axiosIns from "@/libs/axios";
import Ripple from "vue-ripple-directive";
import formValidation from "@core/comp-functions/forms/form-validation";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BForm,
    BFormGroup,
    BFormInvalidFeedback,
    BOverlay,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      loading: false,
      newExpiryDate: '',
      moneylenderNumber: '',
    };
  },
  props: {
    supplier: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { refFormObserver, getValidationState, resetForm } = formValidation();
    return {
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
  methods: {
    hideModal() {
      this.$root.$emit("bv::hide::modal", "modal-update-moneylender-license-expiry");
      this.loading = false;
    },
    handleUpdate(bvModalEvt) {
      // 阻止modal的預設關閉行為
      bvModalEvt.preventDefault();
      
      this.$refs.refFormObserver.validate().then((success) => {
        if (success) {
          this.onSubmit();
        }
      });
    },
    onSubmit() {
      this.$swal({
        title: "你確定嗎?",
        text: "修改放債人牌照到期日及號碼",
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          
          const updateData = {
            id: this.supplier.id,
            moneylender_license_expiry_date: this.newExpiryDate,
            moneylender_number: this.moneylenderNumber,
          };

          axiosIns.put("/supplier/moneylender_license_expiry", updateData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                confirmButtonText: "確定",
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });

              this.$emit("refetch-data");
              this.hideModal();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response?.data?.message || "更新失敗",
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  watch: {
    supplier: {
      handler(newSupplier) {
        if (newSupplier) {
          this.newExpiryDate = newSupplier.moneylender_license_expiry_date || '';
          this.moneylenderNumber = newSupplier.moneylender_number || '';
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.required label::after {
  content: " *";
  color: red;
}
</style>